<template>
  <div>
    <!-- appbar -->
    <v-app-bar color="primary" height="70px" fixed app :style="nav">
      <v-app-bar-nav-icon color="brick" @click.stop="drawer = !drawer">
        <v-icon>mdi-menu</v-icon>
      </v-app-bar-nav-icon>

      <span class="pa-1 logo">
        <img
          v-if="mobileLang.code == 'el'"
          src="@/assets/logo.png"
          alt=""
          style="width: 129px; height: 45px"
        />

        <img
          v-else
          src="@/assets/logo-en.png"
          alt=""
          style="width: 129px; height: 45px"
        />
      </span>

      <v-btn icon @click="openSearchDialog()">
        <v-icon color="brick">mdi-magnify</v-icon>
      </v-btn>
    </v-app-bar>

    <!-- navigation drawer -->
    <v-navigation-drawer
      v-model="drawer"
      :temporary="true"
      app
      color="primary"
      hide-overlay
      width="100%"
    >
      <div :style="drawerLogo"></div>
      <div class="d-flex align-center pa-1 mt-2">
        <v-btn icon color="secondary" @click="drawer = !drawer">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>

      <div class="d-flex flex-column justify-center align-center px-4">
        <span v-if="mobileLang.code == 'el'" class="pa-1 logo mb-10">
          <img
            src="@/assets/logo.png"
            alt=""
            style="width: 230px; height: 80px"
          />
        </span>

        <span v-else class="pa-1 logo mb-10">
          <img
            src="@/assets/logo-en.png"
            alt=""
            style="width: 230px; height: 80px"
          />
        </span>

        <div
          class="flex-grow-1 d-flex flex-column align-self-start"
          style="width: 100%"
        >
          <div v-for="(item, i) in menu" :key="i">
            <v-btn
              v-if="item.type == 'route'"
              class="mb-2 d-flex align-center justify-start active white--text"
              :to="item.path"
              color="white"
              :ripple="false"
              plain
              @click.native="closeDrawer()"
            >
              <v-icon size="25" class="secondary rounded-circle mr-5 pa-1">{{
                item.icon
              }}</v-icon>

              <span class="secondary--text body-1 font-weight">{{
                item.label
              }}</span>
            </v-btn>

            <v-btn
              v-if="item.type == 'link'"
              class="mb-2 d-flex align-center justify-start active white--text"
              :href="item.path"
              color="white"
              :ripple="false"
              plain
              @click.native="closeDrawer()"
            >
              <v-icon size="25" class="secondary rounded-circle mr-5 pa-1">{{
                item.icon
              }}</v-icon>

              <span class="secondary--text body-1 font-weight">{{
                item.label
              }}</span>
            </v-btn>
            <v-divider class="mb-3 px-4"></v-divider>
          </div>
        </div>
      </div>
    </v-navigation-drawer>
    <v-dialog
      v-model="searchDialog.open"
      v-if="searchDialog.open"
      max-width="100%"
      fullscreen
    >
      <SearchModal @close="closeSearchDialog" />
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import SearchModal from "./SearchModal.vue";
export default {
  components: {
    SearchModal,
  },

  data() {
    return {
      drawer: false,
      location: null,
      mini: false,
      status: false,
      searchDialog: {
        open: false,
      },

      filters: [
        {
          label: "Περιοχή",
          value: null,
        },
        {
          label: "Τοποθεσίες ενδιαφέροντος",
          value: null,
        },
        {
          label: "Διαδρομή",
          value: null,
        },
      ],
    };
  },

  computed: {
    ...mapState({
      insets: (state) => state.base.insets,
      mobileLang: (state) => state.base.mobileLang,
    }),

    nav() {
      return {
        padding: `${this.insets?.top}px 0px 0px 0px`,
        height: `calc(70px+${this.insets?.top}px)`,
      };
    },
    drawerLogo() {
      return {
        background: "#C8D0C9",
        padding: `${this.insets?.top}px 0px 0px 0px`,
        height: `calc(70px+${this.insets?.top}px)`,
        display: "grid",
        "place-items": "center",
      };
    },

    menu() {
      return [
        {
          label: this.$t("menu.pois"),
          icon: "mdi-map-marker-multiple",
          path: "/pois",
          type: "route",
        },

        {
          label: this.$t("menu.routes"),
          icon: "mdi-map-marker-path",
          path: "/routes",
          type: "route",
        },

        {
          label: this.$t("menu.contact"),
          icon: "mdi-mail",
          path: "https://www.efales-ar.gr/%ce%b5%cf%80%ce%b9%ce%ba%ce%bf%ce%b9%ce%bd%cf%89%ce%bd%ce%af%ce%b1/",
          type: "link",
        },

        {
          label: this.$t("menu.info_settings"),
          icon: "mdi-cog",
          path: "/settings",
          type: "route",
        },
      ];
    },
  },

  methods: {
    onSearch() {
      console.log("onSearch");
    },

    openSearchDialog() {
      this.searchDialog.open = true;
    },

    closeSearchDialog() {
      this.searchDialog.open = false;
    },

    closeDrawer() {
      this.drawer = false;
    },
  },
};
</script>

<style scoped lang="scss">
.logo {
  // filter: brightness(0) invert(1);
}
.nav-header {
  height: 60px !important;
}

.v-btn--active > .v-btn__content .v-icon {
  color: var(--v-secondary-base) !important;
  background-color: #c5c6a9 !important;
}

.navigation-drawer-title {
  position: relative !important;
}

.v-btn {
  text-transform: none !important;
}

>>> .v-dialog {
  overflow-y: hidden !important;
}
</style>